export class SettingsPageController {
    /*@ngInject*/
    constructor($scope, $state, $rootScope, $timeout, $window, $transitions, $uibModal, StorageService, jobService, settingService, userService, companyService, utilityService, alertsAndNotificationsService, MESSAGECONSTANTS, uibModalService, userRoleService) {
        this.$scope = $scope;
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$window = $window;
        this.$transitions = $transitions;
        this.$uibModal = $uibModal;
        this.StorageService = StorageService;
        this.jobService = jobService;
        this.settingService = settingService;
        this.userService = userService;
        this.companyService = companyService;
        this.utilityService = utilityService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
        this.uibModalService = uibModalService;
        this.userRoleService = userRoleService;
    }
    $onInit() {
        this.$stateParams = this.$transition$.params();
        this._initializeVariables();
        if (this.$stateParams.accessMode === null) {
            this.viewOnlyMode = false;
        }
        else {
            this.viewOnlyMode = true;
        }
        this.isVendorCompany = this.companyService.isCompanyVendor();
        this.$window.addEventListener("beforeunload", () => {
            if (angular.equals(this.$state.$current.name, 'missioncontrol.settings')) {
                this.StorageService.remove('removeSliderId');
                console.log('now removeSliderId and refreshing');
            }
        });
        this._handleDisableSlider();
        this._handleBrowserBackForwardChange();
        this._getSettings();
        this._getAllActivityTypes();
    }
    _initializeVariables() {
        this.currentCompany = this.$rootScope.userDetails.company;
        this.form = {};
        this.form.settingsTypeform = {};
        this.form.performanceSetting = {};
        this.globalSettings = null; //Global Settings
        this.settings = {}; //UI Settings
        this.settings.licensePreferenceSetting = {};
        this.settings.performanceSetting = {};
        this.savedSettings = {}; //Saved Settings Object
        this.allClientsOrBus = [];
        this.allClientsOrBusForCopy = null;
        this.allClientsOrBusForCopyHavingCustomSettings = null;
        this.timeInWorkflowSteps = [];
        this.years = [0, 1, 2];
        this.months = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
        this.days = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
        this.copyChecked = false;
        this.disableCompanyOrClientSettingsSelection = true;
        this.copyClientCheckBox = false;
        this.selectEnable = false;
        this.checkValuesArray = [];
        this.availableClientsToCopy = [];
        this.clientCopy = null;
        this.selectedClientOrBu = {};
        this.selectedClientOrBu.id = null;
        this.isCustomSettingsSelected = false;
        this.delimitedCompanyOrClientName = null;
        this.deleteSettingCounter = 0;
        this.showConfirmationPopup = false;
        this.isClientGlobalCopy = true;
        this.hasAccessToCompanySettings = false;
        this.isValuesInitialized = false;
        this.isCompanySelected = true;
        this.isLocationChange = false;
        this.isLocationChangeInitial = false;
        this.isInHost = this.utilityService.isInHost();
        this.isVendorCompany = false;
        this.globalSettingsCompanyModel = false;
        this.globalSettingsClientModel = false;
        this.isUsersPanelOpen = false;
        this.isRequisitionPanelOpen = false;
        ;
        this.licensePreferencePanelFlags = [];
        this.toggleClientValue = {};
        this.toggleClientValueCopy = {};
        this.companySelectionActive = true;
        this.isClientCopyObject = false;
        this.clientCopyMandatoryMessage = false;
        this.isStillProcessing = true;
        this.isStillProcessingModified = true;
        this.loadingFlag = true;
        this.userRole = this.$rootScope.userDetails.roleScreenRef.role.name;
        this.isStaffingCompany = this.companyService.isStaffingCompany();
        this.isCorporateCompany = this.companyService.isCorporateCompany();
        this.selectedClient = null;
        this.isOutreachPanelOpen = false;
        this.isSuperUserOrAdmin = this.userRoleService.isLoggedInUserSuperUserOr4dot5Admin();
    }
    _getSettings() {
        if (this.isInHost) {
            console.log('Get 4dot5 Settings');
            this.hasAccessToCompanySettings = true;
            this._getFourDotFiveSettings();
        }
        else {
            if ((this.userRole == 'StaffingRecruitingManager' && !this.isVendorCompany) || this.userRole == this.MESSAGECONSTANTS.ROLESNAMES.HIRING_MANAGER || this.userRole == 'CorporateRecruitingManager') {
                this._getClientsOrBus(() => {
                    this._getLoggedInUserDetails(() => {
                        if (this.hasAccessToCompanySettings) {
                            this._getSettingsForStaffingOrCorporateCompany();
                        }
                        else {
                            this.manageClientOrBuSelection();
                        }
                    });
                });
            }
            else {
                console.log('Get Staffing or corporate company Settings');
                this.hasAccessToCompanySettings = true;
                this._getSettingsForStaffingOrCorporateCompany();
            }
        }
    }
    _getFourDotFiveSettings() {
        this.settingService.getFourDotFiveSettings((data) => {
            this.settings = data;
            this._setReminderSettings();
            if (this.isInHost) {
                this.settingsCopyForCompany = angular.copy(data);
            }
            //  this.StorageService.set('removeSliderId', this.settings.performanceSetting.length +1);
            this.settingsCopy = data;
            this.globalSettings = angular.copy(this.settings);
            this.savedSettings = angular.copy(this.settings);
            if (this.$rootScope.userDetails.company.companyType === 'Host') {
                this.$timeout(() => {
                    /*angular.element('#setvalues').trigger('click');*/
                    this.setSliderValues();
                    this.isValuesInitialized = true;
                    this._isGlobalOrCustomSettings();
                }, 500);
            }
            else {
                for (let i = 0; i < this.settings.performanceSetting.length; i++) {
                    this.updateMaxLimitForSliders(i, this.settings.performanceSetting[i].maxLimit);
                }
                this._isGlobalOrCustomSettings();
                this._updateSettingsInView();
            }
            this.isStillProcessing = false;
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    _setReminderSettings() {
        angular.forEach(this.settings.licensePreferenceSetting, (setting, index) => {
            if (setting.reminderInterval > 0) {
                setting.defaultReminderInterval = setting.reminderInterval;
                setting.isReminderEnabled = true;
            }
            else {
                setting.defaultReminderInterval = 2;
                setting.isReminderEnabled = false;
            }
        });
    }
    /**
     * Function to update maxlimit for sliders.
     * Range slider is $index starts from 0
     */
    updateMaxLimitForSliders(rangeSlider, maxLimit) {
        //     console.log(rangeSlider + 'New maxLimit: ' + maxLimit);
        //     console.log('Presently: ' + this.settings.performanceSetting[rangeSlider].maxLimit);
        if ((maxLimit >= this.settings.performanceSetting[rangeSlider].maxValue) && (maxLimit <= 200) && (this.settings.performanceSetting[rangeSlider].maxValue !== 0)) {
            this.settings.performanceSetting[rangeSlider].isSelected = false;
            this.settings.performanceSetting[rangeSlider].maxLimit = maxLimit;
            var sliderIdInUI = this.settings.performanceSetting.length + rangeSlider + 3;
            console.log('slider changing is : ' + sliderIdInUI);
            this.StorageService.set('removeSliderId', sliderIdInUI);
            /*if(this.isInHost){
            }*/
            // console.log('Removing Slider with Id: ' + sliderIdInUI);
            $('.slider-range-' + rangeSlider).empty();
            var performanceSliderValues = this.settings.performanceSetting;
            //performanceSliderValues[0].maxLimit = maxLimit;
            let sliderClass = '.slider-range-' + rangeSlider;
            $(sliderClass).noUiSlider({
                range: [0, maxLimit],
                start: [performanceSliderValues[rangeSlider].minValue, performanceSliderValues[rangeSlider].maxValue],
                step: 1,
                connect: true,
                /*slide: function () {
                    var values = $(sliderClass).val();
                    $(sliderClass).next('span').text(values[0] + ' - ' + values[1]).addClass('sliderBold');
                },
                set: function () {
                    var values = $(sliderClass).val();
                    $(sliderClass).next('span').text(values[0] + ' - ' + values[1]).removeClass('sliderBold');
                    //console.log('Set PerformanceSetting: ' + values[0] + ' - ' + values[1]);
                }*/
                slide: () => {
                    var values = $(sliderClass).val();
                    var fromLabel = $(sliderClass).next('p').find('.fromLabel').text();
                    var toLabel = $(sliderClass).next('p').find('.toLabel').text();
                    if (fromLabel != '' && fromLabel != values[0]) {
                        $(sliderClass).next('p').find('.fromLabel').text(values[0]).addClass('sliderBold');
                    }
                    else if (toLabel != '' && toLabel != values[1]) {
                        $(sliderClass).next('p').find('.toLabel').text(values[1]).addClass('sliderBold');
                    }
                },
                set: () => {
                    var values = $(sliderClass).val();
                    $(sliderClass).next('p').find('.fromLabel').text(values[0]).removeClass('sliderBold');
                    $(sliderClass).next('p').find('.toLabel').text(values[1]).removeClass('sliderBold');
                }
            });
            // console.log('Updating values for slider: ' + rangeSlider);
            $('.slider-range-' + rangeSlider).val([performanceSliderValues[rangeSlider].minValue, performanceSliderValues[rangeSlider].maxValue], true);
            this.settings.performanceSetting[rangeSlider].isError = false;
            this.settings.performanceSetting[rangeSlider].isErrorForMax = false;
        }
        else {
            if (maxLimit > 200) {
                this.settings.performanceSetting[rangeSlider].isErrorForMax = true;
                this.settings.performanceSetting[rangeSlider].isError = false;
            }
            else {
                this.settings.performanceSetting[rangeSlider].isError = true;
                this.settings.performanceSetting[rangeSlider].isErrorForMax = false;
            }
        }
    }
    /**
     * Setting value and render sliders in UI
     */
    setSliderValues() {
        //console.log("setvalues method");
        let sliderValues = this.settings.licensePreferenceSetting;
        for (let i = 0; i < this.settings.licensePreferenceSetting.length; i++) {
            //console.log('Score is: ' + sliderValues[i].score);
            if (sliderValues[i].score != null) {
                let sliderClass = '.slider-setting-' + i;
                $(sliderClass).noUiSlider({
                    range: [0, 100],
                    start: [sliderValues[i].score],
                    handles: 1,
                    step: 0.5,
                    connect: 'lower',
                    slide: () => {
                        var val = $(sliderClass).val();
                        $(sliderClass).next('span').text(val).addClass('sliderBold');
                    },
                    set: () => {
                        var val = $(sliderClass).val();
                        $(sliderClass).next('span').text(val).removeClass('sliderBold');
                    }
                });
                $('.slider-setting-' + i).val(sliderValues[i].score, true);
            }
        }
        for (let i = 0; i < this.settings.licensePreferenceSetting.length; i++) {
            //console.log('Score is: ' + sliderValues[i].timeToComplete);
            let sliderClass = '.slider-setting-timeToComplete-' + i;
            $(sliderClass).noUiSlider({
                range: [0, 10],
                start: [sliderValues[i].timeToComplete],
                handles: 1,
                step: 1,
                connect: 'lower',
                slide: () => {
                    var val = $(sliderClass).val();
                    $(sliderClass).next('span').text(val).addClass('sliderBold');
                },
                set: () => {
                    var val = $(sliderClass).val();
                    $(sliderClass).next('span').text(val).removeClass('sliderBold');
                }
            });
            $('.slider-setting-timeToComplete-' + i).val(sliderValues[i].timeToComplete, true);
        }
        let performanceSliderValues = this.settings.performanceSetting;
        for (let j = 0; j < this.settings.performanceSetting.length; j++) {
            let sliderClass = '.slider-range-' + j;
            $(sliderClass).noUiSlider({
                range: [0, performanceSliderValues[j].maxLimit],
                start: [performanceSliderValues[j].minValue, performanceSliderValues[j].maxValue],
                step: 1,
                connect: true,
                slide: () => {
                    var values = $(sliderClass).val();
                    var fromLabel = $(sliderClass).next('p').find('.fromLabel').text();
                    var toLabel = $(sliderClass).next('p').find('.toLabel').text();
                    if (fromLabel != '' && fromLabel != values[0]) {
                        $(sliderClass).next('p').find('.fromLabel').text(values[0]).addClass('sliderBold');
                    }
                    else if (toLabel != '' && toLabel != values[1]) {
                        $(sliderClass).next('p').find('.toLabel').text(values[1]).addClass('sliderBold');
                    }
                },
                set: () => {
                    var values = $(sliderClass).val();
                    $(sliderClass).next('p').find('.fromLabel').text(values[0]).removeClass('sliderBold');
                    $(sliderClass).next('p').find('.toLabel').text(values[1]).removeClass('sliderBold');
                }
            });
            $('.slider-range-' + j).val([performanceSliderValues[j].minValue, performanceSliderValues[j].maxValue], true);
        }
        this.loadingFlag = false;
    }
    _isGlobalOrCustomSettings() {
        this.isStillProcessing = true;
        if (this.settings.global && this.$rootScope.userDetails.company.companyType != 'Host') {
            // angular.element('.slider-range').attr({ 'disabled': true }); //Disabling double headed sliders.
            // angular.element('.noUi-target').attr({ 'disabled': true }); //Disabling single headed sliders.
            // angular.element('.onoffswitch').addClass('avoid-clicks'); //Disabling switches.
        }
        else {
            for (let index = 0; index < this.settings.licensePreferenceSetting.length; index++) {
                if (this.settings.licensePreferenceSetting[index].isEnabled) {
                    angular.element('.slider-setting-' + index).attr({ 'disabled': false });
                    angular.element('.slider-setting-timeToComplete-' + index).attr({ 'disabled': false });
                }
                else {
                    angular.element('.slider-setting-' + index).attr({ 'disabled': true });
                    // angular.element('.slider-setting-timeToComplete-' + index).attr({ 'disabled': true });
                }
            }
        }
        this.isStillProcessing = false;
    }
    _getClientsOrBus(callback) {
        this.isStillProcessing = true;
        console.log('Getting Clients/Bus');
        this.userService.getUsersOnlyClientsOrBus(this.$rootScope.userDetails.company.companyId, (data) => {
            this.isClientExists = data && data.length > 0;
            this.allClientsOrBus = angular.copy(data);
            angular.forEach(this.allClientsOrBus, (clientOrBu, index) => {
                if (clientOrBu.companyType == 'Corporation') {
                    clientOrBu.aliasName = clientOrBu.aliasName + " &#xf1e0;";
                }
            });
            if (this.allClientsOrBus.length > 0) {
                this.client = this.allClientsOrBus[0];
                this.selectedClientOrBu.id = this.client.companyId;
                console.log('assigned first client : ' + angular.toJson(this.client));
                this.getSettingsForClient(this.client);
                this.checkValuesClientsOrBus = data;
                this.allClientsOrBusForCopy = data;
            }
            else {
                this.isStillProcessing = false;
                this.loadingFlag = false;
            }
            if (callback) {
                callback();
            }
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    getSettingsForClient(client) {
        this.isStillProcessing = true;
        this.loadingFlag = true;
        this.toggleClientValue = client;
        if (client.companyType === "Client" || client.companyType === "Corporation") {
            this.selectedClientNameForMessage = client.companyName;
        }
        else if (client.companyType === "BusinessUnit") {
            this.selectedBUNameForMessage = client.companyName;
        }
        //if(!this.isClientGlobalCopy){
        //$filter('clientorbuModified')(client.companyName, this.isClientGlobalCopy);
        //}
        this.ischeckboxValueNullorNot = document.getElementById("checkbox-inl-1");
        this.globalSettingsClientModel = false;
        this.client = client;
        if (this.availableClientsToCopy.length != 0) {
            this.availableClientsToCopy = [];
            this.allClientsOrBus.forEach((element) => {
                if (element.companyId != client.companyId) {
                    this.availableClientsToCopy.push(element);
                }
                else {
                    console.log('Duplicate : ' + element.companyName + ' not added');
                }
            }, this);
        }
        this.settingService.getClientOrBuSettings(this.$rootScope.userDetails.company.companyId, client.companyId, (data) => {
            this.settings = data;
            this._setReminderSettings();
            this.isClientGlobal = data.global;
            this.isClientGlobalCopy = this.isClientGlobal;
            this.settingsClient = angular.copy(this.settings);
            this.savedSettings = angular.copy(this.settings);
            this.copyChecked = false;
            this.isClientCopyObject = false;
            this.clientCopyMandatoryMessage = false;
            this.$timeout(() => {
                if (!this.isValuesInitialized) {
                    this.setSliderValues();
                    this.isValuesInitialized = true;
                }
                this._isGlobalOrCustomSettings();
            }, 500);
            /*for(i=0; i < this.allClientsOrBus.length; i++){
                this.allClientsOrBus[i].clientCompanyNameCopy = this.allClientsOrBus[i].companyName;
            }*/
            //this.client.clientCompanyNameCopy = $filter('clientorbuModified')(this.client.companyName, this.isClientGlobalCopy);
            this._isGlobalOrCustomSettings();
            this._updateSettingsInView();
            if (!this.viewOnlyMode) {
                this._getClientsOrBusHavingCustomSettings();
            }
            else {
                this.loadingFlag = false;
            }
            //this.isStillProcessing = false;
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    _getLoggedInUserDetails(callback) {
        this.userService.getLoggedInUserDetails((data) => {
            if (!data.isBUsOrClientsAvailable) {
                this.hasAccessToCompanySettings = true;
                if (callback) {
                    callback();
                }
            }
            if (!this.hasAccessToCompanySettings) {
                this._isUserEntityScopeAll(() => {
                    if (callback) {
                        callback();
                    }
                });
            }
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    _isUserEntityScopeAll(callback) {
        // this.userService.getUserRoleEntityScope((data) => {
        // this.hasAccessToCompanySettings = data.allclientOrBU;
        this.hasAccessToCompanySettings = true;
        if (callback) {
            callback();
        }
        // }, (error) => {
        //     if(callback) {
        //         callback();
        //     }
        // });
    }
    _getSettingsForStaffingOrCorporateCompany() {
        this.loadingFlag = true;
        this.isStillProcessingModified = true;
        this.settingService.getCorporateOrStaffingCompanySettings(this.$rootScope.userDetails.company.companyId, (data) => {
            this._massageCompanySettings(data);
            if (!(this.showClientsOrBusList)) {
                this.$timeout(() => {
                    if (!this.isValuesInitialized) {
                        this.setSliderValues();
                        this.isValuesInitialized = true;
                    }
                    this.loadingFlag = false;
                }, 500);
            }
            else {
                this.loadingFlag = false;
            }
            this.isStillProcessingModified = false;
            if (!this.isInHost) {
                this.changeCompanySettings();
            }
            ;
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    _massageCompanySettings(settings) {
        this.settings = settings;
        this._setReminderSettings();
        this.settingsCopyForCompany = angular.copy(settings);
        for (let i = 0; i < this.settings.performanceSetting.length; i++) {
            this.settings.performanceSetting[i].duplicateMaxLImit = this.settings.performanceSetting[i].maxLimit;
            this.settings.performanceSetting[i].isSelected = false;
            this.settings.performanceSetting[i].isError = false;
        }
        this.toggleParentAndChildSettings = angular.copy(this.settings);
        this.savedSettings = angular.copy(this.settings);
    }
    manageClientOrBuSelection() {
        this.isCompanySelected = false;
        this.loadingFlag = true;
        if (this.globalSettingsClientModel) {
            this.isStillProcessing = false;
        }
        else {
            this.isStillProcessing = true;
        }
        this.companySelectionActive = false;
        this.globalSettingsCompanyModel = false;
        this.globalSettingsClientModel = false;
        this.showClientsOrBusList = true;
        this.isClientCopyObject = false;
        this.clientCopyMandatoryMessage = false;
        if (this.copyChecked) {
            document.getElementById("checkbox-inl-1").checked = false;
            this.copyChecked = false;
        }
        //this.client = null;
        if (this.allClientsOrBus.length === 0) {
            this._getClientsOrBus(() => {
                if (this.allClientsOrBus.length > 0) {
                    if (this.toggleClientValue && this.toggleClientValue.company) {
                        if (this.toggleClientValue.company.companyType === "Client") {
                            this.selectedClientNameForMessage = this.toggleClientValue.company.name;
                        }
                        else if (this.toggleClientValue.company.companyType === "BusinessUnit") {
                            this.selectedBUNameForMessage = this.toggleClientValue.company.name;
                        }
                        if (this.showClientsOrBusList && this.client != null && this.copyChecked && this.toggleClientValueCopy.company) {
                            if (this.toggleClientValueCopy.company.companyType === "Client") {
                                this.selectedClientNameForMessageCopy = this.toggleClientValueCopy.company.name;
                            }
                            else if (this.toggleClientValueCopy.company.companyType === "BusinessUnit") {
                                this.selectedBUNameForMessageCopy = this.toggleClientValueCopy.company.name;
                            }
                        }
                    }
                }
                else {
                    this.loadingFlag = false;
                }
            });
        }
        else {
            this.getSettingsForClient(this.client);
        }
    }
    /**
     * Function Re-Render Sliders values on change of settings;
     */
    _updateSettingsInView() {
        // console.log('Updating Setings in view');
        for (var i = 0; i < this.settings.licensePreferenceSetting.length; i++) {
            $('.slider-setting-' + i).val(this.settings.licensePreferenceSetting[i].score, true);
            // $('.slider-setting-timeToComplete-' + i).attr("value", this.settings.licensePreferenceSetting[i].timeToComplete);
            $('.slider-setting-timeToComplete-' + i).val(this.settings.licensePreferenceSetting[i].timeToComplete, true);
            if (!this.settings.licensePreferenceSetting[i].isEnabled) {
                //console.log('Disabling: ' + this.settings.licensePreferenceSetting[i].name);
                angular.element('.slider-setting-' + i).attr({ 'disabled': true });
            }
            //$('.slider-setting-' + i).next('span').text($('.slider-setting-' + i).val());
        }
        for (var i = 0; i < this.settings.performanceSetting.length; i++) {
            $('.slider-range-' + i).val([this.settings.performanceSetting[i].minValue, this.settings.performanceSetting[i].maxValue], true);
            this.settings.performanceSetting[i].maxLimit = this.settings.performanceSetting[i].maxLimit;
        }
    }
    isModifyClientSelected() {
        return !this.isInHost && !this.companySelectionActive;
    }
    /**
     * Toggle company , client or bu radio button
     */
    manageCompanySelection() {
        console.log('Show Staffing/Corporate settings');
        this.isCompanySelected = true;
        this.companySelectionActive = true;
        this.globalSettingsCompanyModel = false;
        this.globalSettingsClientModel = false;
        this.isClientCopyObject = false;
        this.clientCopyMandatoryMessage = false;
        this.allClientsOrBus = [];
        this.isClientGlobalCopy = true;
        // this.$scope.safeApply();
        this.client = null;
        this.copyClientCheckBox = false;
        this.copyChecked = false;
        this.toggleClientValue = {};
        this.showClientsOrBusList = false;
        if (!this.settingsCopyForCompany) {
            this._getSettingsForStaffingOrCorporateCompany();
        }
        else {
            this.settings = angular.copy(this.settingsCopyForCompany);
            this._isGlobalOrCustomSettings();
        }
        this._updateSettingsInView();
    }
    //UI events handler methods
    /**
     * Change company settings type.
     */
    changeCompanySettings() {
        this.settings = angular.copy(this.settingsCopyForCompany);
        this.savedSettings = angular.copy(this.settingsCopyForCompany);
        //console.log(angular.equals(this.settings,this.savedSettings));
        this._isGlobalOrCustomSettings();
        this._updateSettingsInView();
        this.globalSettingsCompanyModel = false;
        //this.settings.global = false;
        for (var index = 0; index < this.settings.licensePreferenceSetting.length; index++) {
            if (this.settings.licensePreferenceSetting[index].isEnabled) {
                // console.log('Enabling: ' + this.settings.licensePreferenceSetting[index].name);
                angular.element('.slider-setting-' + index).attr({ 'disabled': false });
                angular.element('.slider-setting-timeToComplete-' + index).attr({ 'disabled': false });
            }
        }
        angular.element('.slider-range').attr({ 'disabled': false });
        angular.element('.onoffswitch').removeClass('avoid-clicks');
        this.selectEnable = false;
        this.isCustomSettingsSelected = true;
    }
    /**
     * Change client settings type.
     */
    changeClientSettings() {
        this.isClientCopyObject = false;
        this.clientCopyMandatoryMessage = false;
        this.settings = angular.copy(this.settingsClient);
        this.savedSettings = angular.copy(this.settingsClient);
        //console.log(angular.equals(this.settings,this.savedSettings));
        this._isGlobalOrCustomSettings();
        this._updateSettingsInView();
        this.globalSettingsClientModel = false;
        //this.settings.global = false;
        if (this.copyChecked) {
            document.getElementById("checkbox-inl-1").checked = false;
            this.copyChecked = false;
        }
        for (var index = 0; index < this.settings.licensePreferenceSetting.length; index++) {
            if (this.settings.licensePreferenceSetting[index].isEnabled) {
                angular.element('.slider-setting-' + index).attr({ 'disabled': false });
                angular.element('.slider-setting-timeToComplete-' + index).attr({ 'disabled': false });
            }
        }
        angular.element('.slider-range').attr({ 'disabled': false });
        angular.element('.onoffswitch').removeClass('avoid-clicks');
        this.selectEnable = false;
        this.isCustomSettingsSelected = true;
    }
    /**
     * Global settings at both company and client level.
     */
    changeGlobalSettings() {
        this.isClientCopyObject = false;
        this.clientCopyMandatoryMessage = false;
        //console.log(this.copyChecked);
        if (this.copyChecked) {
            document.getElementById("checkbox-inl-1").checked = false;
            this.copyChecked = false;
        }
        //this.settings.global = true;
        // angular.element('.slider-range').attr({ 'disabled': true });
        // angular.element('.noUi-target').attr({ 'disabled': true });
        // angular.element('.onofsfswitch').addClass('avoid-clicks');
        this.isCustomSettingsSelected = false;
        this.selectEnable = true;
        if (!this.companySelectionActive) {
            console.log("Gets settings for Staffing/Corpoarte Company with reference to client.");
            this.globalSettingsClientModel = true;
            this._getParentSettings();
        }
        else {
            console.log("Gets settings for FourDotFive Company.");
            console.log(angular.equals(this.savedSettings, this.settingsCopyForCompany));
            this.globalSettingsCompanyModel = true;
            this._getFourDotFiveSettings(); //Gets settings for FourDotFive Company.
        }
    }
    _getParentSettings() {
        this.settingService.getParentCompanySettings(this.$rootScope.userDetails.company.companyId, (data) => {
            this.isStillProcessing = true;
            this.settings = data;
            this._setReminderSettings();
            for (let i = 0; i < this.settings.performanceSetting.length; i++) {
                this.settings.performanceSetting[i].duplicateMaxLImit = this.settings.performanceSetting[i].maxLimit;
                this.settings.performanceSetting[i].isSelected = false;
                this.settings.performanceSetting[i].isError = false;
            }
            this.toggleParentAndChildSettings = angular.copy(this.settings);
            this.savedSettings = angular.copy(this.settings);
            this._isGlobalOrCustomSettings();
            this._updateSettingsInView();
            this.isStillProcessing = false;
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    /**
     * Change settings type.
     */
    /*this.changeSettingsType = function (settingsType) {
        console.log('Setting type: ' + settingsType);
        if (settingsType === 'globalsettings') {
            this.selectedClientSettings=false;
            this.selectedClientSettingsCopy=false;
            this.selectedCompanySettings=false;
            this.selected4dot5Settings=true;
            this.selectedBUSettings=false;
            this.selectedBUSettingsCopy=false;
            angular.element('.slider-range').attr({ 'disabled': true });
            angular.element('.noUi-target').attr({ 'disabled': true });
            // angular.element('.access').attr({ 'disabled': true });

            angular.element('.onoffswitch').addClass('avoid-clicks');
            this.isCustomSettingsSelected = false;
            this.selectEnable = true;
            if (this.showClientsOrBusList) {
                this._getParentSettings(); //Gets settings for Staffing/Corpoarte Company with reference to client.
                console.log("Gets settings for Staffing/Corpoarte Company with reference to client.");
                this.selected4dot5Settings = false;
                this.selectedCompanySettings = true;
            } else {
                console.log("Gets settings for FourDotFive Company.");
                this._getFourDotFiveSettings();  //Gets settings for FourDotFive Company.
            }
        } else {
//                	this.selectedClientSettings=false;
//                	this.selectedCompanySettings=true;
//                	this.selected4dot5Settings=false;
            this.onClickCompanyModifySettings = true;
            console.log("this.globalSettingsCompanyModel"+this.globalSettingsCompanyModel);
            for (var index = 0; index < this.settings.licensePreferenceSetting.length; index++) {
                if (this.settings.licensePreferenceSetting[index].isEnabled) {
                    console.log('Enabling: ' + this.settings.licensePreferenceSetting[index].name);
                    angular.element('.slider-setting-' + index).attr({ 'disabled': false });
                    angular.element('.slider-setting-timeToComplete-' + index).attr({ 'disabled': false });
                    // angular.element('.dropdowns-for-' + index).attr({ 'disabled': false });
                }
            }
            
            angular.element('.noUi-target').attr({ 'disabled': false });
            angular.element('.access').attr({ 'disabled': false });

            angular.element('.slider-range').attr({ 'disabled': false });
            angular.element('.onoffswitch').removeClass('avoid-clicks');
            this.selectEnable = false;
            this.isCustomSettingsSelected = true;
        }
        console.log('this.isCustomSettingsSelected: ' + this.isCustomSettingsSelected);
    }
*/
    /**
     * This function is called on click of cancel to reset scope variables.
     */
    cancel() {
        if (this.companySelectionActive) {
            // this._changeCompanySettingsBeforeSave();
            // if (!angular.equals(this.savedSettings, this.settingsCopyForCompany)) {
            this.settings = angular.copy(this.settingsCopyForCompany);
            this._updateSettingsInView();
            if (!this.isInHost) {
                this.globalSettingsCompanyModel = false;
                this.changeCompanySettings();
            }
            // }
        }
        else if (!this.companySelectionActive) {
            //this._changeClientSettingsBeforeSave();
            //if(!angular.equals(this.savedSettings, this.settingsClient)) {
            this.settings = angular.copy(this.settingsClient);
            this._updateSettingsInView();
            this.globalSettingsClientModel = false;
            this.copyChecked = false;
            //}
            this.changeClientSettings();
        }
    }
    reminderEnabledOrDisabled(settingIndex) {
        let reminderSetting = angular.copy(this.settings.licensePreferenceSetting[settingIndex]);
        if (reminderSetting.isReminderEnabled) {
            reminderSetting.reminderInterval = reminderSetting.defaultReminderInterval;
        }
        else {
            reminderSetting.reminderInterval = 0;
        }
        this.settings.licensePreferenceSetting[settingIndex] = angular.copy(reminderSetting);
    }
    onClientOrBuChange() {
        let selectedClientOrBu = _.filter(this.allClientsOrBus, { companyId: this.selectedClientOrBu.id })[0];
        this._getClientSettings(selectedClientOrBu);
        if (!this.viewOnlyMode) {
            document.getElementById("checkbox-inl-1").checked = false;
        }
    }
    _getClientSettings(selectedClient) {
        if (angular.isUndefined(selectedClient)) {
            return;
        }
        else {
            this.getSettingsForClient(selectedClient);
        }
    }
    /**
     * This function is to get setting from the client from which settings are to be copied.
     */
    getSettingsForClientToCopy(clientCopy) {
        if (clientCopy) {
            this.isStillProcessing = true;
            this.toggleClientValueCopy = clientCopy;
            this.isClientCopyObject = true;
            this.clientCopyMandatoryMessage = false;
            if (clientCopy.company.companyType === "Client" || clientCopy.company.companyType === "Corporation") {
                this.selectedClientNameForMessageCopy = clientCopy.company.name;
            }
            else if (clientCopy.company.companyType === "BusinessUnit") {
                this.selectedBUNameForMessageCopy = clientCopy.company.name;
            }
            this.clientCopy = clientCopy;
            if (angular.isDefined(clientCopy)) {
                this.loadingFlag = true;
                this.settingService.getClientOrBuSettings(this.$rootScope.userDetails.company.companyId, clientCopy.company.id, (data) => {
                    this.settings = data;
                    this._setReminderSettings();
                    this.savedSettings = data;
                    this._isGlobalOrCustomSettings();
                    this._updateSettingsInView();
                    this.loadingFlag = false;
                }, (error) => {
                    if (this.$rootScope.isOnline) {
                        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    }
                });
            }
            //this.isStillProcessing = false;
        }
    }
    setSettings() {
        if (this.companySelectionActive) {
            this._setSettingsForCompany();
        }
        else {
            this._setSettingsForClientOrBU();
        }
    }
    _setSettingsForCompany() {
        console.log("ENtered set settings for company");
        this._changeCompanySettingsBeforeSave();
        if (!this.settingsCopyForCompany.global && angular.equals(this.savedSettings, this.settingsCopyForCompany)) {
            //Nothing to be saved.
            console.log('Nothing to be saved for company.');
            this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.NOTHING_TO_SAVE, 'success');
        }
        else if (!this.isInHost && this.globalSettingsCompanyModel) {
            console.log('Delete global for company and save new settings for company.' + angular.toJson(this.$rootScope.userDetails.company));
            this.settingService.deleteStaffingOrCorpSettings(this.$rootScope.userDetails.company.companyId, (data) => {
                console.log('Deleted Custom Settings company: ' + angular.toJson(data));
                this.globalSettingsCompanyModel = false;
                this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.SETTINGS.SETTINGS_FOR_COMPANY + " '<b><i class='wrap-word'>" + this.$rootScope.userDetails.company.companyName + "</i></b>' " + this.MESSAGECONSTANTS.NOTIFICATIONS.SETTINGS.UPDATE_SUCCESS, 'success');
                this.settingService.getCorporateOrStaffingCompanySettings(this.$rootScope.userDetails.company.companyId, (data) => {
                    this._massageCompanySettings(data);
                }, (error) => {
                    if (this.$rootScope.isOnline) {
                        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    }
                    this.$state.go('missioncontrol.dashboard', null, { reload: true });
                });
            }, (error) => {
                if (this.$rootScope.isOnline) {
                    this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
                this.cancel();
            });
        }
        else if ((this.settingsCopyForCompany.global || !angular.equals(this.savedSettings, this.settingsCopyForCompany))) {
            console.log('Update custom settings for company.');
            this.settingService.setCompanySettings(this.$rootScope.userDetails.company.companyId, this.savedSettings, (response) => {
                console.log('Update Custom Settings : ' + angular.toJson(response));
                this.settingService.getCorporateOrStaffingCompanySettings(this.$rootScope.userDetails.company.companyId, (data) => {
                    this.settings = data;
                    this._setReminderSettings();
                    this.settingsCopyForCompany = angular.copy(this.settings);
                    this.savedSettings = angular.copy(this.settings);
                    if (!this.isInHost) {
                        //                    	     this.modifySettingsCompanyModel=false;
                        //                           this.globalSettingsCompanyModel=false;
                        //                           document.getElementById('modifySettingsCompany').checked = false;
                        //                           document.getElementById('globalSettingsCompany').checked = false;
                        this.toggleParentAndChildSettings = angular.copy(this.settings);
                    }
                    else {
                        this.settingsCopy = data;
                        this.globalSettings = angular.copy(this.settings);
                    }
                    this.alertsAndNotificationsService.showBannerMessage(response.message, 'success');
                }, (error) => {
                    if (this.$rootScope.isOnline) {
                        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    }
                });
            }, (error) => {
                if (this.$rootScope.isOnline) {
                    this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
                this.cancel();
            });
        }
    }
    _changeCompanySettingsBeforeSave() {
        this.savedSettings = angular.copy(this.settings);
        //Update custom settings.
        for (let i = 0; i < this.settings.performanceSetting.length; i++) {
            delete this.settings.performanceSetting[i].duplicateMaxLImit;
            delete this.settings.performanceSetting[i].isSelected;
            delete this.settings.performanceSetting[i].isError;
            delete this.settings.performanceSetting[i].isErrorForMax;
            delete this.savedSettings.performanceSetting[i].duplicateMaxLImit;
            delete this.savedSettings.performanceSetting[i].isSelected;
            delete this.savedSettings.performanceSetting[i].isError;
            delete this.savedSettings.performanceSetting[i].isErrorForMax;
        }
        for (var j = 0; j < this.settings.performanceSetting.length; j++) {
            let minMaxValues = $('.slider-range-' + j).val();
            this.savedSettings.performanceSetting[j].minValue = Number(minMaxValues[0]);
            this.savedSettings.performanceSetting[j].maxValue = Number(minMaxValues[1]);
        }
        //Updating the score values from view.
        for (var j = 0; j < this.settings.licensePreferenceSetting.length; j++) {
            if (this.settings.licensePreferenceSetting[j].score != null) {
                this.savedSettings.licensePreferenceSetting[j].score = Number($('.slider-setting-' + j).val());
            }
            // console.log( this.savedSettings.licensePreferenceSetting[j].score, this.settings.licensePreferenceSetting[j].score);
        }
        //Updating the time to complete days from view.
        for (var j = 0; j < this.settings.licensePreferenceSetting.length; j++) {
            if (this.settings.licensePreferenceSetting[j].timeToComplete != null) {
                this.savedSettings.licensePreferenceSetting[j].timeToComplete = Number($('.slider-setting-timeToComplete-' + j).val());
            }
        }
        if (this.isInHost) {
            console.log("Entered license preference host");
            var minMaxValues;
            //Updating the range values from view.
            for (var j = 0; j < this.settings.performanceSetting.length; j++) {
                console.log("Entered license preference host");
                minMaxValues = $('.slider-range-' + j).val();
                this.savedSettings.performanceSetting[j].minValue = Number(minMaxValues[0]);
                this.savedSettings.performanceSetting[j].maxValue = Number(minMaxValues[1]);
            }
        }
    }
    /**
     * This function is to set Settings for the Staffing/Corporate company or Client/Bu.
     */
    _setSettingsForClientOrBU() {
        if (!((this.client != null) && this.copyChecked && (this.clientCopy === null))) {
            this._changeClientSettingsBeforeSave();
            this.clientCopyMandatoryMessage = false;
            if (!this.settingsClient.global && angular.equals(this.savedSettings, this.settingsClient)) {
                //Nothing to be saved.
                this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.NOTHING_TO_SAVE, 'success');
            }
            else if (this.globalSettingsClientModel) {
                let clientDetails = {
                    isClientCompanySettingsActivity: this.client.companyType == 'Corporation'
                };
                //Delete global for client and save new settings for client.
                this.settingService.deleteClientOrBuSettings(this.$rootScope.userDetails.company.companyId, this.client.companyId, clientDetails, (data) => {
                    console.log('Deleted Custom Settings : ' + angular.toJson(data));
                    console.log('Deleted Custom Settings : ' + angular.toJson(this.client));
                    this.globalSettingsClientModel = false;
                    this._changeClientName();
                    this.getSettingsForClient(this.client);
                    this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.SETTINGS.SETTINGS_FOR + '' + this.client.companyType + " '<b><i class='wrap-word'>" + this.client.companyName + "</i></b>' " + this.MESSAGECONSTANTS.NOTIFICATIONS.SETTINGS.UPDATE_SUCCESS, 'success');
                }, (error) => {
                    if (this.$rootScope.isOnline) {
                        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    }
                    this.cancel();
                });
            }
            else if ((this.settingsClient.global || !angular.equals(this.savedSettings, this.settingsClient))) {
                //Update custom settings.
                console.log('Update custom settings for client.');
                this.settingService.setClientOrBuSettings(this.$rootScope.userDetails.company.companyId, this.client.companyId, this.savedSettings, (data) => {
                    console.log('Update Custom Settings : ' + angular.toJson(data));
                    //                        this.modifySettingsClientModel=false;
                    //                        this.globalSettingsClientModel=false;
                    //                        document.getElementById('modifySettingsClient').checked = false;
                    //                        document.getElementById('globalSettingsClient').checked = false;
                    if (this.copyChecked) {
                        document.getElementById("checkbox-inl-1").checked = false;
                        this.copyChecked = false;
                    }
                    this.settings = data;
                    this._setReminderSettings();
                    this.isClientGlobal = data.global;
                    this.isClientGlobalCopy = this.isClientGlobal;
                    this.settingsClient = angular.copy(this.settings);
                    this.savedSettings = angular.copy(this.settings);
                    this.isClientCopyObject = false;
                    this.clientCopyMandatoryMessage = false;
                    this._changeClientName();
                    this.alertsAndNotificationsService.showBannerMessage(data.message, 'success');
                }, (error) => {
                    if (this.$rootScope.isOnline) {
                        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    }
                    this.cancel();
                });
            }
        }
        else {
            this._showCopyClientValidationAlert();
            //this.clientCopyMandatoryMessage = true;
        }
    }
    _changeClientSettingsBeforeSave() {
        this.savedSettings = angular.copy(this.settings);
        for (let i = 0; i < this.settings.performanceSetting.length; i++) {
            delete this.settings.performanceSetting[i].duplicateMaxLImit;
            delete this.settings.performanceSetting[i].isSelected;
            delete this.settings.performanceSetting[i].isError;
            delete this.savedSettings.performanceSetting[i].duplicateMaxLImit;
            delete this.savedSettings.performanceSetting[i].isSelected;
            delete this.savedSettings.performanceSetting[i].isError;
        }
        for (let j = 0; j < this.settings.performanceSetting.length; j++) {
            let minMaxValues = $('.slider-range-' + j).val();
            this.savedSettings.performanceSetting[j].minValue = Number(minMaxValues[0]);
            this.savedSettings.performanceSetting[j].maxValue = Number(minMaxValues[1]);
        }
        //Updating the score values from view.
        for (let j = 0; j < this.settings.licensePreferenceSetting.length; j++) {
            if (this.settings.licensePreferenceSetting[j].score != null) {
                this.savedSettings.licensePreferenceSetting[j].score = Number($('.slider-setting-' + j).val());
            }
            // console.log( this.savedSettings.licensePreferenceSetting[j].score, this.settings.licensePreferenceSetting[j].score);
        }
        //Updating the time to complete days from view.
        for (let j = 0; j < this.settings.licensePreferenceSetting.length; j++) {
            if (this.settings.licensePreferenceSetting[j].timeToComplete != null) {
                this.savedSettings.licensePreferenceSetting[j].timeToComplete = Number($('.slider-setting-timeToComplete-' + j).val());
            }
        }
    }
    _changeClientName() {
        this.userService.getUsersOnlyClientsOrBus(this.$rootScope.userDetails.company.companyId, (data) => {
            this.clientsOrBUsList = data;
            for (let i = 0; i < this.clientsOrBUsList.length; i++) {
                for (let k = 0; k < this.allClientsOrBus.length; k++) {
                    if (this.allClientsOrBus[k].companyId === this.clientsOrBUsList[i].companyId) {
                        this.allClientsOrBus[k].aliasName = this.clientsOrBUsList[i].aliasName;
                        if (this.allClientsOrBus[k].companyId === this.client.companyId) {
                            this.client.aliasName = this.allClientsOrBus[k].aliasName;
                        }
                    }
                }
            }
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    _showCopyClientValidationAlert() {
        if (this.isStaffingCompany) {
            var copyMessage = 'Please select a Client to copy from.';
        }
        else {
            var copyMessage = 'Please select a BU to copy from.';
        }
        bootbox.alert({
            closeButton: false,
            title: '<div class="alert alert-danger"><i class="fa fa-times-circle fa-fw fa-lg"></i><strong>Oh snap!</strong></div>',
            message: copyMessage,
            callback: () => {
            }
        });
    }
    /**
     * This function is to get all the clients/bus for the Staffing/Corporate company.
     */
    _getClientsOrBusHavingCustomSettings() {
        this.isStillProcessing = true;
        this.loadingFlag = true;
        console.log('Getting Clients/Bus with custom settings');
        this.companyService.getClientsOrBusHavingCustomSettings(this.$rootScope.userDetails.company.companyId, (data) => {
            console.log('Getting Clients/Bus with custom settings api success');
            data.length == 0 ? this.copyClientCheckBox = false : '';
            this.availableClientsToCopy = [];
            data.forEach((element) => {
                if (element.company.id != this.client.companyId) {
                    this.availableClientsToCopy.push(element);
                    //console.log(this.availableClientsToCopy.length)
                    this.copyClientCheckBox = true;
                }
                else {
                    //                            console.log('Duplicate : ' + element.company.name + ' not added');
                }
            }, this);
            if (this.availableClientsToCopy.length < 1) {
                this.copyClientCheckBox = false;
            }
            this.isStillProcessing = false;
            console.log('loaded available clients to copy dropdown');
            this.loadingFlag = false;
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    /**
     * Function to this.cancel(hide the save and cancel buttons that appear on edit of maxlimit).
     */
    cancelTimeForSliders(rangeSlider) {
        this.settings.performanceSetting[rangeSlider].isSelected = false;
        this.settings.performanceSetting[rangeSlider].isError = false;
        this.settings.performanceSetting[rangeSlider].isErrorForMax = false;
        this.settings.performanceSetting[rangeSlider].duplicateMaxLImit = this.settings.performanceSetting[rangeSlider].maxLimit;
    }
    /**
     * Function to toggle edit options for range sliders.
     */
    toggleEditOptionForSliders(rangeSliderIndex) {
        //   console.log('Edit Range maxlimit: ' + rangeSliderIndex);
        this.settings.performanceSetting[rangeSliderIndex].duplicateMaxLImit = this.settings.performanceSetting[rangeSliderIndex].maxLimit;
        this.settings.performanceSetting[rangeSliderIndex].isSelected = true;
    }
    isCopyChecked() {
        //this.modifySettingsClientModel=false;
        this.globalSettingsClientModel = false;
        this.isClientCopyObject = false;
        this.clientCopyMandatoryMessage = false;
        this.availableClientsToCopy = [];
        this.clientCopy = null;
        this.copyChecked = document.getElementById("checkbox-inl-1").checked;
        if (this.copyChecked) {
            this._getClientsOrBusHavingCustomSettings();
        }
        else {
            this.settings = angular.copy(this.settingsClient);
            this.savedSettings = angular.copy(this.settingsClient);
            this._isGlobalOrCustomSettings();
            this._updateSettingsInView();
        }
        /*this.allClientsOrBus.forEach(function (element) {
            if (element.company.id != this.client.company.id) {
                this.availableClientsToCopy.push(element);
            } else {
                console.log('Duplicate : ' + element.company.name + ' not added');
            }
        }, this);*/
        //                this.$timeout(function () {
        //                   // console.log('Items to copy array: ' + angular.toJson(this.availableClientsToCopy));
        //                    if(this.copyChecked){
        //                    	this.clientCopy = this.availableClientsToCopy[0];
        //                    	this.getSettingsForClientToCopy(this.clientCopy);
        //                    }else{
        //                    	this.getSettingsForClient(this.client);
        //                    }
        //                }, 50)
    }
    onMetricsValueChange(metricsEnum, changedTo, metricIndex, metricStepIndex) {
        let minValue = 0;
        let maxValue = 100;
        if (metricsEnum == "TIME_IN_WORKFLOW_STEP") {
            maxValue = 50;
        }
        if (changedTo == undefined) {
            changedTo = 0;
        }
        else if (changedTo > maxValue) {
            changedTo = maxValue;
        }
        else if (changedTo < minValue) {
            changedTo = minValue;
        }
        this.settings.metricsForWorkflowSteps[metricIndex].steps[metricStepIndex].value = changedTo;
    }
    isSectionActive() {
        if (this.isInHost) {
            return true;
        }
        else {
            if (this.globalSettingsClientModel || this.globalSettingsCompanyModel || this.viewOnlyMode) {
                return false;
            }
            else {
                return true;
            }
        }
    }
    //            this.$scope.$on('$stateChangeStart', function (event, toState, fromState, toParams) {
    //                console.log('Moving out.................');
    //                this.StorageService.remove('removeSliderId');
    //                this.StorageService.set('outOfPage', 'movingOut');
    //            });
    _handleDisableSlider() {
        $('#disable-checkbox').click(() => {
            if (this.checked) {
                // Disable the slider
                disableSlider.attr("disabled", "disabled");
            }
            else {
                // Enabled the slider
                disableSlider.removeAttr("disabled");
            }
        });
    }
    //Handle navigating away when data is unsaved
    uiCanExit(transitions) {
        let toState = transitions.to().name;
        let toParams = transitions.params();
        if (this._isSettingsChanged() && toState !== "login") {
            transitions.abort();
            bootbox.confirm({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Warning!</strong></div>",
                message: "Unsaved data on the page will be lost. Do you still want to continue?",
                buttons: {
                    confirm: {
                        label: 'Yes',
                        className: 'btn-success'
                    },
                    cancel: {
                        label: 'Cancel',
                        className: 'btn-danger'
                    }
                },
                callback: (result) => {
                    if (result) {
                        this.cancel();
                        this.StorageService.remove('removeSliderId');
                        this.StorageService.set('outOfPage', 'movingOut');
                        this.StorageService.remove('wizardoperations');
                        // Handling data change when clicked on Switch company
                        if (this.$rootScope.switchClicked) {
                            this.$rootScope.switchClicked = false;
                            // this.companyService.showAllCompanies();
                            this.uibModalService.showAllCompanies();
                        }
                        else {
                            this.$state.go(toState, toParams, { reload: true });
                        }
                    }
                    else {
                        if (this.$rootScope.switchClicked) {
                            this.$rootScope.switchClicked = false;
                        }
                    }
                }
            });
        }
        else {
            // If clicked on switch company without changing data
            if (this.$rootScope.switchClicked && !this._isSettingsChanged()) {
                transitions.abort();
                this.$timeout(() => {
                    // this.companyService.showAllCompanies();
                    this.uibModalService.showAllCompanies();
                }, 150);
                this.$rootScope.switchClicked = false;
            }
        }
    }
    _handleBrowserBackForwardChange() {
        let unbindLocationChangeEvent = this.$scope.$on('$locationChangeStart', (event, toState, toParams, fromState, fromParams) => {
            this.isLocationChange = this.isLocationChangeInitial;
            this.isLocationChangeInitial = true;
        });
    }
    /**
     * UNbind state for Warning message pop
     */
    _isSettingsChanged() {
        if (this.companySelectionActive) {
            this._changeCompanySettingsBeforeSave();
            if ((angular.equals(this.savedSettings, this.settingsCopyForCompany)) || (!this.isInHost && this.globalSettingsCompanyModel && !angular.equals(this.savedSettings, this.settingsCopyForCompany))) {
                return false;
            }
            else {
                return true;
            }
        }
        else {
            this._changeClientSettingsBeforeSave();
            if (this.allClientsOrBus.length > 0) {
                if ((angular.equals(this.savedSettings, this.settingsClient)) || (this.globalSettingsClientModel && !angular.equals(this.savedSettings, this.settingsClient))) {
                    return false;
                }
                else {
                    return true;
                }
            }
            else {
                return false;
            }
        }
    }
    _getAllActivityTypes() {
        this.jobService.getActivityTypes((data) => {
            this.activityMap = [];
            angular.forEach(data, (val, key) => {
                this.activityMap[val.value] = val.name;
            });
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    viewActivities() {
        let companyId = null;
        let context = "companySettings";
        let isSharedClient = false;
        if (this.isCompanySelected) {
            companyId = this.$rootScope.userDetails.company.companyId;
        }
        else if (this.selectedClientOrBu.id !== null) {
            companyId = this.selectedClientOrBu.id;
            context = "clientOrBuSettings";
            isSharedClient = this.client.companyType == 'Corporation';
        }
        let actionType = 'activities';
        let actionLabel = "Setting Activities";
        let modalWindowClass = "four-dot-five-modal-medium";
        let actionsModal = this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            windowClass: modalWindowClass,
            component: 'settingsActionsModal',
            resolve: {
                actionType: () => {
                    return actionType;
                },
                actionLabel: () => {
                    return actionLabel;
                },
                activityMap: () => {
                    return this.activityMap;
                },
                companyId: () => {
                    return companyId;
                },
                isSharedClient: () => {
                    return isSharedClient;
                },
                context: () => {
                    return context;
                }
            }
        });
    }
    isOutReachSettingEditable() {
        return this.settings.outReachSetting && ((this.isInHost && this.settings.outReachSetting.enabled)
            || (!this.isInHost && this.settings.outReachSetting.enabled && this.settings.hostOrParentEnabled));
    }
}
SettingsPageController.$inject = ['$scope', '$state', '$rootScope', '$timeout', '$window', '$transitions', '$uibModal', 'StorageService', 'jobService', 'settingService', 'userService', 'companyService', 'utilityService', 'alertsAndNotificationsService', 'MESSAGECONSTANTS', 'uibModalService', 'userRoleService'];
// import * as TEMPLATE from './settings-page.html';
import * as TEMPLATE from 'raw-loader!./settings-page.html';
export const SettingsPageComponent = {
    selector: 'settingsPage',
    component: {
        bindings: { $transition$: '<' },
        // templateUrl: 'app/partials/missioncontrol/settings/settings-page.html',
        template: TEMPLATE.default,
        controller: SettingsPageController
    }
};
//# sourceMappingURL=settings-page.component.js.map